import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { AumyeSecurityPassService } from 'src/app/services/aumye-security-pass.service';

@Component({
  selector: 'app-visitor-entry',
  templateUrl: './visitor-entry.component.html',
  styleUrls: ['./visitor-entry.component.scss'],
})
export class VisitorEntryComponent implements OnInit {
  qrData = '';
  visitorId: string;
  visitDate: any;
  visitorData: any;
  securityStatus = 0;
  status: string;
  visitorSecurityEPass = this.formbuilder.group({
    visID: [],
    hostID: [],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.email]],
    phone: ['', Validators.required],
    address: [],
    purpose: ['', Validators.required],
    carReg: [],
    photoID: [''],
    meeting: ['', Validators.required],
    profilePic: [''],
    status: [''],
    qrCode: [''],
  });
  constructor(
    private activeRoute: ActivatedRoute,
    private formbuilder: FormBuilder,
    private securityPassService: AumyeSecurityPassService
  ) {
    this.activeRoute.queryParams.subscribe((params) => {
      this.visitorId = params['id'];
    });
    this.qrData = window.location.href;
  }
  ngOnInit(): void {
    this.securityPassService.getVisitorData(this.visitorId).subscribe((res) => {
      this.visitorData = res;
      this.setVisitorSecurityForm(res);
    });
  }
  setVisitorSecurityForm(val: any) {
    this.visitorSecurityEPass.controls.firstName.setValue(val.firstName);
    this.visitorSecurityEPass.controls.lastName.setValue(val.lastName);
    this.visitorSecurityEPass.controls.visID.setValue(val.visitorID);
    this.visitorSecurityEPass.controls.hostID.setValue(val.hostUserId);
    this.visitorSecurityEPass.controls.email.setValue(val.email);
    this.visitorSecurityEPass.controls.phone.setValue(val.phoneNumber);
    this.visitorSecurityEPass.controls.address.setValue(val.visitorAddress);
    this.visitorSecurityEPass.controls.carReg.setValue(val.carRegistration);
    this.visitorSecurityEPass.controls.meeting.setValue(val.hostName);
    this.visitorSecurityEPass.controls.profilePic.setValue(val.profilePicture);
    this.visitorSecurityEPass.controls.photoID.setValue(val.profilePicture);
    this.visitorSecurityEPass.controls.status.setValue(val.securityStatus);
    this.visitorSecurityEPass.controls.qrCode.setValue(this.qrData);
    this.visitDate = val.visitDateTime;
    this.visitDate = moment(this.visitDate, 'MMMM Do YYYY, h:mm:ss a');
    this.securityStatus = Number(
      this.visitorSecurityEPass.controls.status.value
    );
    this.status = !this.securityStatus ? 'Unverified' : 'Verified';
  }
  onSubmitVisitorPassGuard() {
    this.securityStatus = 1;
    this.status = !this.securityStatus ? 'Unverified' : 'Verified';
  }
}
